import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import DiariasService from '../../../../../services/diarias-auth';
import { Link } from 'react-router-dom';
import '../../../../../styles/diario.scss';



const FormBusca = (props) => {
    const [indice, setIndice] = useState("");
    const [cargo, setCargo] = useState("");
    const [distancia, setDistancia] = useState("");


    const busca = async (query) => {
        if (query == "") {
            await props.fetchDiarias()
            setIndice("")
            setCargo("")
            setDistancia("")
        } else {
            var response = await DiariasService.buscar(query)
            if (response.data.length >= 1) {
                props.setDiarias(response.data)
                props.setVazio(false)
                setIndice("")
                setCargo("")
                setDistancia("")
            } else {
                props.setVazio(true)
                setIndice("")
                setCargo("")
                setDistancia("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (indice !== "false" && indice !== "") prepQuery = prepQuery + `&indice=${indice}`;
        if (cargo) prepQuery = prepQuery + `&cargo=${encodeURI(cargo)}`;
        if (distancia !== "false" && distancia !== "") prepQuery = prepQuery + `&distancia=${encodeURI(distancia)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="indice">
                                <FloatingLabel
                                    label="Índice"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="indice"
                                        name="indice"
                                        onChange={e => setIndice(e.target.value)}
                                    >
                                        <option>TODOS</option>
                                        <option value="I">I</option>
                                        <option value="II">II</option>
                                        <option value="III">III</option>
                                        <option value="IV">IV</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="cargo">
                                <FloatingLabel
                                    label="Cargo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="cargo"
                                        value={cargo}
                                        onChange={e => setCargo(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="distancia">
                                <FloatingLabel
                                    label="Distância"
                                    className="mb-3"
                                >
                                     <Form.Select
                                        aria-label="distancia"
                                        name="distancia"
                                        onChange={e => setDistancia(e.target.value)}
                                    >
                                        <option>TODAS</option>
                                        <option value="ate 80km">Até 80Km</option>
                                        <option value="acima de 80km">Acima 80Km</option>
                                        <option value="independente do Estado">Todos Estados</option>
                                        <option value="dentro do Estado">Estado do Rio de Janeiro</option>
                                        <option value="outros Estados">Para fora do Rio de Janeiro</option>
                                        <option value="Acima de 100km">Acima de 100k</option>
                                        <option value="Brasília">Brasília/DF</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/diarias'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
